module.exports = __webpack_public_path__ + "static/media/Less.e460dbd1.svg";